import { customElement } from 'lit/decorators.js';
import { BaseComponent } from '@src/components/BaseComponent.js';

@customElement('tef-coms-cancel-button')
export class TefComsCancelButton extends BaseComponent {
  override render() {
    return this.getTemplateFn('tefComsCancelButton')();
  }

  handleClick() {
    this.triggerEvent({
      name: 'action/CANCEL',
      level: 'info',
      message: 'cancel action invoked',
    });
  }

  // Render into lightDOM
  protected createRenderRoot() {
    return this;
  }
}
